import { useParams } from "react-router-dom";
import ChatSidebar from "../../components/chat/ChatSidebar";
import ChatPanel from "../../components/chat/ChatPanel";
import React from "react";

function ChatsLayout() {
  const { id: chatId } = useParams();

  return (
    <section className="messenger-section" id="Csection">
      <ChatSidebar />
      {chatId ? (
        <ChatPanel chatId={chatId} />
      ) : (
        <section className="chat-section d-none d-lg-block">
          <div className="chat-label">
            <div className="">
              <div className="d-flex justify-content-center">
                <i className="fa-solid fa-envelope fa-5x text-primary"></i>
              </div>
              <h2>
                Вітаю в месенджері <strong className="text-uppercase">Project</strong>
              </h2>
              <p>Пишіть повідомлення людям приватно або в групі</p>
            </div>
          </div>
        </section>
      )}
    </section>
  );
}

export default ChatsLayout;